import { css } from "@emotion/react";

export const styles = {
  fill: css`
    width: 100%;
  `,
  base: css`
    display: flex;
    flex-wrap: no-wrap;
    gap: var(--spacing-24);
    .bp4-control {
      margin-bottom: 0;
    }
  `,
  stacked: css`
    flex-direction: column;
    gap: var(--spacing-16);
  `,
  withLabel: css`
    margin-top: var(--spacing-8);
  `,
  chipGroup: css`
    flex-wrap: wrap;
    gap: var(--spacing-8);
  `,
  error: css`
    border: 1px solid var(--color-danger);
    border-radius: var(--border-radii-base);
    padding: var(--spacing-8);
  `
};
